import React from 'react';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const DeprecatedReviewRegisterPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const reviewUrl = `/customer/orders/review/${id}/register`;
    navigate(reviewUrl);
  }, []);

  return <React.Fragment />;
};
